import { reserveRideSeat } from '../../services/customer/ticketBookingServices';

export default async function reserveSeat({
  ride,
  statement,
  setChosenSeats,
  seat,
  wagonNumber,
  prices,
}) {
  const carriage = ride?.carriages?.find(
    (car) => `${car?.order_number}` === `${wagonNumber}`,
  ) ?? ride?.carriages?.[wagonNumber - 1];
  const values = {
    statementGuid: statement?.guid,
    statementId: statement?.id,
    rideNumber: ride?.rideNumber,
    seatNumber: seat.seat_number,
    carriageId: carriage?.carriage_id,
    carriageOrderNumber: carriage?.order_number,
    seatGroupPropertyId: seat?.seat_group_property_id,
    seatGroupPropertyItemId: seat?.seat_group_property_item_id,
  };
  const response = await reserveRideSeat(values);
  if (response.status === 'success') {
    setChosenSeats((prevState) => [
      ...prevState,
      {
        id: response?.data?.id,
        seat_number: seat.seat_number,
        seat_class: seat.seat_class_id,
        wagon_number: wagonNumber,
        guid: values.statementGuid,
        carriage_id: carriage?.carriage_id,
        statement_id: response.data.id,
        initial_seat_price: prices[seat.seat_class_id],
        seat_group_property_id: seat?.seat_group_property_id,
        seat_group_property_item_id: seat?.seat_group_property_item_id,
      },
    ]);
  }
}
